import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { ProjectField } from './shared'
import { BugtrackerRequest } from '../../bugtrackers/api/shared'
import {
  getProjectFields,
  GetProjectFieldsArgs
} from './requests/get-project-fields'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseProjectFieldsQueryProps {
  organizationUuid: string
  bugtrackerRequest: BugtrackerRequest | null
  projectId?: string
  issueTypeId?: number
}

export interface ProjectFieldsQueryResponse {
  data?: {
    fields: ProjectField[]
    priorityFieldAvailable: boolean
  }
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseProjectFieldsQuery = (
  props: UseProjectFieldsQueryProps
) => ProjectFieldsQueryResponse

export const useProjectFieldsQuery: UseProjectFieldsQuery = ({
  organizationUuid,
  bugtrackerRequest,
  projectId,
  issueTypeId
}: UseProjectFieldsQueryProps) => {
  const { data, error, isError, isLoading } = useContrastQuery<
    GetProjectFieldsArgs,
    {
      fields: ProjectField[]
      priorityFieldAvailable: boolean
    }
  >(
    [
      Query.INTEGRATIONS_PROJECT_FIELDS_JIRA,
      organizationUuid,
      projectId,
      issueTypeId
    ],
    getProjectFields,
    {
      organizationUuid,
      bugtrackerRequest,
      projectId,
      issueTypeId
    },
    {
      enabled: !!bugtrackerRequest && !!projectId && !!issueTypeId
    }
  )

  return {
    data,
    error,
    isError,
    isLoading
  }
}
